import { DateTime } from 'luxon';

export const getTimezoneAsString = (): string => {
  const date = DateTime.now();
  const isDST = date.isInDST;
  const offset = date.offset - (isDST ? 60 : 0);
  const absoluteOffset = Math.abs(offset);
  const operator = offset > 0 ? '+' : '-';
  const hours = `00${Math.floor(absoluteOffset / 60)}`.slice(-2);
  const minutes = `00${absoluteOffset % 60}`.slice(-2);

  return `${operator}${hours}:${minutes}`;
};
